import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-questionnaire',
  templateUrl: './ui-questionnaire.component.html',
  styleUrls: ['./ui-questionnaire.component.scss']
})
export class UiQuestionnaireComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
